import storage from './storage'

export default function getToken() {

    return storage.get('token')

}